import React from 'react'
import { injectIntl } from 'react-intl'
import styled from 'styled-components'
import { breakpoints, media, ResponsiveContainer } from 'app/assets/styles'
import { H2 } from 'app/common/typography'
import Responsive from 'react-responsive'
import Modal from 'react-modal'
import { ModalTitle } from 'app/common/modals'
import type { IntlShape } from 'react-intl'
import { CookiesManagement } from 'app/common/cookies/management'

type Props = {
    open: boolean,
    handleClose: (e: SyntheticEvent<>) => void,
    intl: IntlShape
}

const CookiesManagementModalComponent = (props: Props) => {
    const { open, handleClose, intl } = props
    const cookiesTitle = intl.formatMessage({
        id: 'cookies.management.title'
    })

    return (
        <Responsive minWidth={breakpoints.medium}>
            {mediumScreens => (
                <Modal
                    isOpen={open}
                    ariaHideApp={true}
                    shouldCloseOnOverlayClick={mediumScreens}
                    onRequestClose={handleClose}
                    style={
                        mediumScreens ? modalStyleDesktop : modalStyleMobile
                    }>
                    <ModalContent>
                        <ModalTitle
                            titleNode={<StyledH2>{cookiesTitle}</StyledH2>}
                            handleClose={handleClose}
                        />
                        <CookiesManagement />
                    </ModalContent>
                </Modal>
            )}
        </Responsive>
    )
}

const modalStyleMobile = {
    overlay: {
        zIndex: 10000
    },
    content: {
        padding: 0,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        border: 'none',
        borderRadius: 0,
        outline: 'none'
    }
}

const modalStyleDesktop = {
    overlay: {
        zIndex: 10000,
        overflow: 'scroll',
        background: 'rgba(0,0,0,0.4)'
    },
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        transform: 'translate(-50%, -50%)',
        border: 'none'
    }
}

const ModalContent = styled(ResponsiveContainer)`
    margin-bottom: 50px;
    ${media.medium`
        width: 900px;
        margin: auto;
    `};
`

const StyledH2 = styled(H2)`
    margin-left: 20px;
    ${media.large`
        margin: 0;
    `}
`

const CookiesManagementModal = injectIntl(CookiesManagementModalComponent)

export { CookiesManagementModal }
